import { Grid, InputAdornment, makeStyles, TextField, Typography } from "@material-ui/core";
import { useState, useEffect } from "react";
import SelectCountry from "./SelectCountry";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },

  input: {
    padding: theme.spacing(1.5),
  },
  prefix: {
    marginRight: theme.spacing(1.5),
  },
  select: {
    paddingRight: 0,
  },
}));

const CountryCodePicker = ({
  containerStyle,
  label,
  name,
  placeHolder,
  value,
  onChange,
  onFocus,
  fullWidth,
  error,
  helperText,
  inputRootStyle,
  id,
  variant,
  labelRoot,
  disabled,
  style,
  type,
  justifyContent = "center",
  countryCode,
  onBlur,
}) => {
  const classes = useStyles();
  const [country, setCountry] = useState("");

  useEffect(() => {
    setCountry(countryCode);
  }, [countryCode]);

  return (
    <Grid id={id} className={containerStyle || classes.root} container direction="column">
      {label && <Typography className={labelRoot}>{label}</Typography>}
      <Grid container alignItems="center" justifyContent={justifyContent}>
        <TextField
          variant={variant || "outlined"}
          type={type}
          value={value}
          onChange={(event) => {
            onChange(event.target.value, country);
          }}
          onFocus={onFocus}
          placeholder={placeHolder}
          onBlur={() => {
            const phone = `${country}${value}`;
            onBlur(name, phone);
          }}
          fullWidth={fullWidth}
          style={style}
          disabled={disabled}
          InputProps={{
            classes: {
              input: inputRootStyle || classes.input,
            },
            startAdornment: (
              <InputAdornment className={classes.select} position="start">
                <SelectCountry setCountry={setCountry} country={country} />
              </InputAdornment>
            ),
          }}
          error={!!error}
          helperText={helperText || typeof error === "string" ? helperText || error : null}
        />
      </Grid>
    </Grid>
  );
};

export default CountryCodePicker;
